export default {
  id: 223,
  title: 'Target #223 - UFO',
  url: 'https://cssbattle.dev/play/223',
  colors: ['#2F434E', '#E25C57', '#F3AC3C'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{width:160}p[a],p[c]{background:#e25c57}body{background:#2f434e}p{position:fixed;margin:0}p[a]{top:87;left:120;height:80;border-radius:1in 1in 0 0}p[b]{top:167;left:70;border-style:solid;border-width:0 50px 46px;border-color:#f3ac3c #2f434e}p[c]{top:183;left:110;width:20;height:20;border-radius:1in;box-shadow:80px 0 #e25c57,160px 0 #e25c57',
}
